export default __webpack_public_path__ + "static/media/tiger_media_logo_yellow.0d71527f.png";